import mask from 'jquery.maskedinput/src/jquery.maskedinput';
import openFormStatus from '../form/form';

// указываем нужную форму
const form = $('.callback-modal');

// функция открытитя модального окна
function openModal(currentForm) {
  // показываем модальное окно
  currentForm.show();
  currentForm.prev('.form-modal__overlay-callback').show();

  // Начинаем слушать клавишу Esc. При её нажатии, закарываем окно.
  $(document).on('keyup', function (e) {
    if (e.keyCode === 27) {
      closeModal();
    }
  });
}

function closeModal() {
  $('.form-modal__overlay-callback, .callback-modal.form-modal').hide();
}

// закрываем модальное окно
$('.closeCallbackModal').click(function () {
  closeModal();
});

// при клике по кнопке открытия формы обратного звонка...
$('.openCallbackModal').click(function (e) {
  e.preventDefault();

  // показываем модальное окно
  openModal(form);
});

// при клике по кнопке открытия формы обратного звонка для заказа роутера...
$('.openCallbacRouterModal').click(function (e) {
  e.preventDefault();

  // показываем модальное окно
  openModal(form);

  // изменяем заголовок окна
  $('.callback-modal .section-header__header').html('Нужен Wi-Fi роутер?');
});

$('#userCallbackContactPhone').mask("+7 (999) 999-99-99");

// отправка формы
$('#userCallbackContactForm').submit(function (event) {
  event.preventDefault();

  const userName = $("#userCallbackContactName").val();
  const userPhone = $("#userCallbackContactPhone").val();

  console.log(userName + ' - ' + userPhone);

  $.post('https://api.groupw.ru/mtrend/demands/join/person', {

    phone: userPhone,
    name: userName,
    demandSource: 'Заявка с сайта'

  }, function (response) {
    console.log(response);

    closeModal();
    openFormStatus('Заявка принята', 'Наш сотрудник позвонит Вам <br>в течение 10 минут.');
  });
});



// WEBPACK FOOTER //
// ./app/blocks/form-callback/form-callback.js